/**
 * Black Matte VTC - Booking Service
 * All booking-related API calls
 * NO business logic - pure API calls only
 */

import apiClient from './apiClient';

export const bookingService = {
  /**
   * Get price estimate for a route
   * @param {Object} params - Route parameters
   * @returns {Promise<Object>} Price estimate response
   */
  async getEstimate(params) {
    const { pickupAddress, destinationAddress, pickupLat, pickupLng, destinationLat, destinationLng } = params;
    
    return apiClient.post('/api/bookings/estimate', {
      pickup_address: pickupAddress,
      destination_address: destinationAddress,
      pickup_lat: pickupLat,
      pickup_lng: pickupLng,
      destination_lat: destinationLat,
      destination_lng: destinationLng,
    });
  },

  /**
   * Get available ride options
   * @param {Object} params - Route parameters
   * @returns {Promise<Object>} Ride options response
   */
  async getRideOptions(params) {
    const { pickupAddress, destinationAddress, passengers, pickupLat, pickupLng, destinationLat, destinationLng } = params;
    
    return apiClient.post('/api/ride-options', {
      pickup_address: pickupAddress,
      destination_address: destinationAddress,
      passengers: passengers || 1,
      pickup_lat: pickupLat,
      pickup_lng: pickupLng,
      destination_lat: destinationLat,
      destination_lng: destinationLng,
    });
  },

  /**
   * Create a new booking
   * @param {Object} bookingData - Booking details
   * @returns {Promise<Object>} Created booking
   */
  async createBooking(bookingData) {
    return apiClient.post('/api/bookings', bookingData);
  },

  /**
   * Get booking by reference
   * @param {string} reference - Booking reference
   * @returns {Promise<Object>} Booking details
   */
  async getBooking(reference) {
    return apiClient.get(`/api/bookings/${reference}`);
  },

  /**
   * Track booking status
   * @param {string} reference - Booking reference
   * @returns {Promise<Object>} Booking tracking info
   */
  async trackBooking(reference) {
    return apiClient.get(`/api/tracking/booking/${reference}`);
  },

  /**
   * Update booking status (admin/driver)
   * @param {string} bookingId - Booking ID
   * @param {Object} statusUpdate - Status update data
   * @returns {Promise<Object>} Updated booking
   */
  async updateBookingStatus(bookingId, statusUpdate) {
    return apiClient.put(`/api/bookings/${bookingId}/status`, statusUpdate);
  },
};

export default bookingService;
